/**
 * Synthetic user message when the user removes one filter chip.
 * Keeps other filters from that search; never defaults missing location to Colombo.
 *
 * @param {'spaceType'|'location'|'date'|'peopleCount'|'maxPrice'} removeKey
 * @param {object} filters - msg.filters from the agent search result
 * @returns {string}
 */
export const buildChipRemovalMessage = (removeKey, filters = {}) => {
  const type = filters.spaceType?.trim() || null;
  const loc = filters.location?.trim() || null;
  const scope = loc ? `in ${loc}` : 'across Sri Lanka';
  const budget = filters.maxPrice
    ? ` under LKR ${Number(filters.maxPrice).toLocaleString()}`
    : '';

  switch (removeKey) {
    case 'maxPrice':
      return 'search without a budget limit';
    case 'peopleCount':
      return 'search without a minimum capacity';
    case 'date':
      if (type) return `show ${type} ${scope}${budget} without a specific date`;
      return `show spaces ${scope}${budget} without a specific date`;
    case 'location':
      if (type) return `show ${type} across Sri Lanka${budget}`;
      return `show spaces across Sri Lanka${budget}`;
    case 'spaceType':
      if (loc) return `show all space types in ${loc}${budget}`;
      return `show all space types across Sri Lanka${budget}`;
    default:
      return '';
  }
};
